import React from "react";
import {List} from "@mui/material";
import RequestItem from "./RequestItem";

export default function RequestList(props){

    return <List>{props.content.map((value, key)=>(<RequestItem {...value} key={key} handleClose={props.handleClose} />))}</List>

}